import column from './config/column'
import grouped from './config/grouped'
import horizontalStacked from './config/horizontalStacked'
import hybrid from './config/hybrid'
import pie from './config/pie'
import stacked from './config/stacked'
import line from './config/line'
import horizontalGrouped from './config/horizontalGrouped'

import {
  ColumnSchema,
  GroupedSchema,
  HorizontalStackedSchema,
  HorizontalGroupedSchema,
  HybridSchema,
  PieSchema,
  StackedSchema,
  LineSchema
} from './validators'

const AMCHART_GROUPED = 'AMCHART_GROUPED'
const AMCHART_STACKED = 'AMCHART_STACKED'
const AMCHART_HORIZONTAL_STACKED = 'AMCHART_HORIZONTAL_STACKED'
const AMCHART_HORIZONTAL_GROUPED = 'AMCHART_HORIZONTAL_GROUPED'
const AMCHART_COLUMN = 'AMCHART_COLUMN'
const AMCHART_LINE = 'AMCHART_LINE'
const AMCHART_HYBRID = 'AMCHART_HYBRID'
const AMCHART_PIE = 'AMCHART_PIE'

export const AmChartTypes = {
  AMCHART_GROUPED,
  AMCHART_STACKED,
  AMCHART_COLUMN,
  AMCHART_LINE,
  AMCHART_HYBRID,
  AMCHART_HORIZONTAL_STACKED,
  AMCHART_HORIZONTAL_GROUPED,
  AMCHART_PIE
}

export const schemaMap = {
  [AMCHART_LINE]: {
    Schema: LineSchema,
    Config: line
  },
  [AMCHART_GROUPED]: {
    Schema: GroupedSchema,
    Config: grouped
  },
  [AMCHART_STACKED]: {
    Schema: StackedSchema,
    Config: stacked
  },
  [AMCHART_COLUMN]: {
    Schema: ColumnSchema,
    Config: column
  },
  [AMCHART_HYBRID]: {
    Schema: HybridSchema,
    Config: hybrid
  },
  [AMCHART_HORIZONTAL_STACKED]: {
    Schema: HorizontalStackedSchema,
    Config: horizontalStacked
  },
  [AMCHART_HORIZONTAL_GROUPED]: {
    Schema: HorizontalGroupedSchema,
    Config: horizontalGrouped
  },
  [AMCHART_PIE]: {
    Schema: PieSchema,
    Config: pie
  }
}
